const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.NEWSLETTER)

export const apiNewsletter = {
	fetchNewsletterByEmail: async (email: string): Promise<INewsletterByEmailModel> => {
		const { data } = await apiCommon<INewsletterByEmail>(`${groupPrefix}/by-email`, {
			method: 'GET',
			...createSimpleQuery({ email }),
		})

		return newsletterByEmailFromJSON(data)
	},
	deleteNewsletterSubscriber: async (email: string): Promise<INewsletterDeleteResultModel> => {
		const { data } = await apiCommon<INewsletterDeleteResult>(`${groupPrefix}`, {
			method: 'DELETE',
			body: { email },
		})

		return newsletterDeleteResultFromJSON(data)
	},
	fetchNewsletterSubscribers: async ({
		search,
		page = 1,
		perPage = 25,
		signal,
	}: {
		search?: string
		page?: number
		perPage?: number
		signal?: AbortSignal
	}): Promise<IApiResponseModel<INewsletterSubscriberModel[]>> => {
		const { data, meta } = await apiCommon<INewsletterSubscriber[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery({ page, perPage }, { search }),
			...(signal ? { signal } : {}),
		})

		return { data: data.map(newsletterSubscriberFromJSON), meta }
	},
}
